const SPAZIO_DATA: Record<string, { image: string; label: string }> = {
  amici: { image: '/images/icons/amici.webp', label: 'Amici' },
  campetto: { image: '/images/icons/campetto.webp', label: 'Campetti di Basket e Calcio' },
  calcio: { image: '/images/icons/campo-calcio.webp', label: 'Campi di Calcio' },
  basket: { image: '/images/icons/canestro.webp', label: 'Campi di Basket' },
  pingpong: { image: '/images/icons/pingpong.webp', label: 'Tavoli da Ping Pong' },
  balilla: { image: '/images/icons/calciobalilla.webp', label: 'Calciobalilla' },
  scatola: { image: '/images/icons/puzzle.webp', label: 'Giochi in scatola' },
  giochi: { image: '/images/icons/joystick.webp', label: 'Giochi' },
  calcetto: { image: '/images/icons/campo-calcio.webp', label: 'Campo da Calcetto' },
  altro: { image: '/images/icons/joystick.webp', label: 'Altro' },
};

const SPAZIO_DEFAULT = { image: '/images/icons/joystick.webp', label: '' };

function findSpazio(nome: string): { image: string; label: string } {
  const l = nome.toLowerCase();
  for (const [k, v] of Object.entries(SPAZIO_DATA)) {
    if (l.includes(k)) return v;
  }
  return { image: SPAZIO_DEFAULT.image, label: nome };
}

export function getSpazioImage(nome: string): string {
  return findSpazio(nome).image;
}

export function getSpazioText(nome: string): string {
  return findSpazio(nome).label;
}
